import axios from "axios";

const actionGetInterpolationReport = async ({commit}, payload) => {
  const interpolations = await axios.get(`${process.env.VUE_APP_URL_API}/v1/reports/milk_interpolations`, {params:{animals:payload}});
  commit("SET_MILK_INTERPOLATION", interpolations.data.analysis);
}

export default {
  actionGetInterpolationReport
}